import styled from 'styled-components'

const Style = {
	Container: styled.div`
		display: flex;
		align-items: center;
		justify-content: center;
		width: fit-content;

		img {
			transition: transform 0.3s ease;
			${(props) =>
				props.loading &&
				`
				animation: rotate 1s linear infinite;
			`}
		}

		@keyframes rotate {
			from {
				transform: rotate(0deg);
			}
			to {
				transform: rotate(360deg);
			}
		}
	`,
}

export default Style
